import * as React from "react"
import {useEffect} from "react"
import {AutocompleteSeeker} from "@ui-seeker/core"

import {useRepricingFormData} from "../../@hooks";


const OPTIONS = [
    { label: 'Monday', value: '0' },
    { label: 'Tuesday', value: '1' },
    { label: 'Wednesday', value: '2' },
    { label: 'Thursday', value: '3' },
    { label: 'Friday', value: '4' },
    { label: 'Saturday', value: '5' },
    { label: 'Sunday', value: '6' }
]

export default function RepricingFormWeekdaysSelect({ enabled }) {
    const { days, handleChangeValue } = useRepricingFormData()

    useEffect(() => {
        if (!enabled)
            handleChangeValue('frequency', [])
    }, [enabled])

    if (!enabled)
        return <></>

    return <AutocompleteSeeker
        multiple
        options={OPTIONS}
        label="Weekdays Filters"
        placeholder="All days"
        value={days}
        onChange={e => handleChangeValue('frequency', e.target.value)}
    />
}